import { FieldType } from "src/types/genericFrom.types";

const data: FieldType[] = [
  {
    component: "Text",
    name: "email",
    props: {
      label: "ایمیل",
      required: true,
      width: "full",
      isPrice: false,
    },
  },
];

export default data;
